<div *ngIf='entry.Filename' class="row outer">
    <div class="col-3">
        <div class="card-body">
            <h5 class="card-title">{{entry.Title}}</h5>
            <h6 *ngIf="entry.Award">{{entry.Award}}</h6>
            <div class="card-text">{{entry.FirstName }} {{entry.LastName }}<br>
                <ng-container *ngIf="entry.Country === 'United States'; then us; else country">           
                </ng-container>
                <ng-template #us>
                    {{entry.City | titlecase}}, {{entry.State | uppercase}}<br>
                </ng-template>
                <ng-template #country>
                    {{entry.Country | titlecase}}<br>
                </ng-template>
                <span *ngIf='entry.Price > 0'>${{entry.Price}}</span>
            </div>
                <span *ngIf='entry.UnframedWidth && entry.UnframedHeight' class="badge badge-pill badge-light">Dimensions: {{entry.UnframedHeight}}" x {{entry.UnframedWidth}}"</span>
                <span *ngIf='entry.FramedWidth && entry.FramedHeight' class="badge badge-pill badge-light">Framed: {{entry.FramedHeight}}" x {{entry.FramedWidth}}"</span>
        </div>
    </div>
    <div class="col-9 align-self-start">
        <img class="img-fluid" src="{{entry.TNFilename}}"/>
    </div>    
</div>